import useAssessmentService from 'domain/people/employee/assessment/assessmentService';
import React from 'react';
import { DESC, List } from 'framework/list';
import AssessmentSectionContent from './AssessmentSectionContent';

const AssessmentSection = () => {
  const { search } = useAssessmentService();

  return (
    <List getDataMethod={request => search({ ...request, sort: { assessmentDate: DESC } })} pageSize={30}>
      <AssessmentSectionContent />
    </List>
  );
};

export default AssessmentSection;
